import DC2500E from "../../assets/images/DC2500E_5.jpg";

const AllModelsBennar = () => {
  return (
    <>
      <div className="">
        <div className="relative">
          <img src={DC2500E} alt="" className="w-[-webkit-fill-available]" />
          <div
            className="
        bottom-0 
        absolute 
        text-[#F2F2F2CC] 
        font-extrabold 
        font-[Rockwell]

        2xl:text-[187px]
        lg:text-[104px]
        md:text-[85px] 
        sm:text-[65px] 
        text-[35px] 

        2xl:leading-[137px]
        lg:leading-[74px]
        md:leading-[60px] 
        sm:leading-[47px] 
        leading-[28px]

        flex justify-center items-center w-[-webkit-fill-available]"
          >
            BUILT TO WORK
          </div>
        </div>
      </div>
    </>
  );
};
export default AllModelsBennar;
